<template>
	<div class="archive" :class="'archive-'+currentPostType">
		<div>
			<FilteredPostsList
				:taxonomy="(currentPostType == 'post' ? 'category' : currentPostType+'_cat')"
				:postType="currentPostType"
				filters
				:key="(currentPostType == 'post' ? 'category' : currentPostType+'_cat')"
			/>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import { mapActions } from 'vuex'
import FilteredPostsList from '@/components/blocks/FilteredPostsList'

export default {
	name: 'archive',
	props: ['page'],
	data(){
		return {
			posts: [],
			hasMore: false,
			nextPage: 1,
			maxItems: 0,
			maxPages: 0,
			isLoading: false,
		}
	},
	computed: {
    },
	components: {
		FilteredPostsList
	},
	mounted() {
		//this.loadPosts()
	},
	methods:{
		fixLink: link => link.replace(WPVUE.home_url, ''),


		
	}
}
</script>
